<template>
  <div
    v-if="block"
    class="flex flex-col items-start gap-4"
    :class="isBorder ? 'mb-4 bg-back-3 rounded-xl p-4' : ''">
    <div class="flex justify-center items-center w-10 h-10 rounded-full" :class="block.iconBg">
      <BaseSymbol v-if="block.symbol" :name="block.symbol" />
      <BaseIcon v-else :name="block.icon" color="var(--text-4)" />
    </div>
    <div class="flex flex-col gap-1 w-full">
      <div class="flex items-center gap-1.5">
        <div
          v-if="kycStatus === KYC_STATUS.SUCCESS"
          class="shrink-0 rounded-full bg-event-green w-[6px] h-[6px]" />
        <div class="truncate text-base leading-[1.5] font-semibold text-text-1">
          {{ $t(block.title) }}
        </div>
      </div>
      <div class="text-xs leading-[1.5] font-medium text-text-4">
        {{ $t(block.description) }}
      </div>
    </div>
    <span
      v-if="kycStatus === KYC_STATUS.PENDING"
      class="text-xs leading-[1.5] font-medium text-text-9 [&_span]:text-primary-main [&_span]:cursor-pointer"
      v-html="safeHtml($t('profile|ifInterruptedProcess'))"
      @click="onInterruptedTextClick" />
    <BaseButton
      v-if="block.action"
      :type="block.buttonType"
      size="sm"
      class="![--base-button-width-default:auto]"
      @click="openKYCWidget">
      {{ $t(block.action) }}
    </BaseButton>
  </div>
</template>

<script setup>
import { safeHtml } from "@/utils/coinhold/safeHtml";
import { computed } from "vue";
import { useKycStore } from "@/stores/kyc";
import BaseIcon from "@emcd-shared/base-icon";
import BaseSymbol from "@emcd-shared/base-symbol";
import BaseButton from "@emcd-shared/base-button";
import { useUserStore, KYC_STATUS } from "@/stores/user";

const props = defineProps({
  isBorder: {
    type: Boolean,
    default: true,
  },
  // Кнопка сразу открывает виджет Sumsub, без вводного экрана «3 шага» (для модалки статуса)
  openWidgetDirectly: {
    type: Boolean,
    default: false,
  },
});

const kycStore = useKycStore();
const userStore = useUserStore();

const kycStatus = computed(() => userStore.getKycStatus());

const BLOCKS = {
  [KYC_STATUS.START]: {
    icon: "profile_scan",
    iconBg: "bg-back-35",
    title: "profile|verification",
    description: "profile|passVerification",
    action: "profile|passButton",
    buttonType: "cta",
  },
  [KYC_STATUS.PENDING]: {
    symbol: "status_alert",
    iconBg: "bg-[#3A2502]",
    title: "profile|documentCheck",
    description: "profile|takes20min",
  },
  [KYC_STATUS.ERROR]: {
    symbol: "status_error",
    iconBg: "bg-[#480F0E]",
    title: "profile|verificationFailed",
    description: "profile|failKYCDetails",
    action: "profile|passKYCAgain",
    buttonType: "error",
  },
  [KYC_STATUS.SUCCESS]: {
    icon: "profile_scan",
    iconBg: "bg-back-35",
    title: "profile|verifiedKYC",
    description: "profile|personVerified",
  },
};

const block = computed(() => BLOCKS[kycStatus.value]);

const openKYCWidget = () => {
  if (props.openWidgetDirectly) {
    kycStore.setIsKYCPendingModalOpen(false);
    kycStore.setIsKYCWidgetOpen(true);
    return;
  }
  kycStore.setIsKYCModalOpen(true);
};

// The link part of the sentence comes from the translation as a <span>
const onInterruptedTextClick = (event) => {
  if (event.target !== event.currentTarget) openKYCWidget();
};
</script>
